import Skeleton from './src/index.vue'

export default Skeleton
